<template>
  <div id="results" :class="{ home: home === true }">
    <div v-if="home === true">
      <b-container class="mobNocontainer">
        <b-row
          class="homeLeader"
          :class="{ homewidthTakover: takeover == true }"
        >
          <b-col>
            <template v-if="web_sponsor !== ''">
              <b-img v-if="data.code != '1001'" class='courseLogo' :src='web_sponsor'></b-img>
            </template>
            <template v-else>       
              <b-img v-if="data.code != '1001'" class='courseLogo' :src='data.event_sponsor_logo'></b-img>
              <b-img v-else class="courseLogo" :src="data.event_sponsor_logo"></b-img>
            </template>
            <template v-if="tmparams.use_full_name == 'N'">
              <h3 class="homeHead">{{ data.short_name }} {{ liveOn }} - {{ title }}</h3>
            </template>
            <template v-else>
              <h3 class="homeHead">{{ data.full_name }} {{ liveOn }} - {{ title }}</h3>
            </template>
            <div class="homecourseDates">{{ data.course_dates }}</div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-row v-else class="title">
      <b-col class="titleLeftmobileWidth">
            <template v-if="tmparams.use_full_name == 'N'">
              <h3 class="homeHead">{{ data.short_name }} - {{ title }}</h3>
            </template>
            <template v-else>
              <h3 class="homeHead">{{ data.full_name }} - {{ title }}</h3>
            </template>
      </b-col>
      <b-col class="informationMobilewidth">
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
          <img class="informationImg" v-b-toggle="'collapse-1'" src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/bvt/2024/07/Information.png">
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :previousData="previousData"
          :home="home"
          :title="title"
          :config="config"
          :team="team"
          :match="match"
          :code="data.code"
          :report="report"
          :live="live"
          :season="data.season"
          :takeover="takeover"
          :bbTeamEvent="data.bball_team"
          :roundsplayed="data.rounds_played"
          :showGender="showGender"
          :Stableford="Stableford"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :previousData="previousData"
          :home="home"
          :title="title"
          :config="config"
          :team="team"
          :match="match"
          :code="data.code"
          :report="report"
          :live="live"
          :season="data.season"
          :takeover="takeover"
          :bbTeamEvent="data.bball_team"
          :roundsplayed="data.rounds_played"
          :showGender="showGender"
          :Stableford="Stableford"
        />
      </b-collapse>
    </template>
    <table>
      <thead>
        <tr v-if="home === false">
          <template> </template>
          <template v-if="tablePick === 'Final'">
            <th>
              Pos
            </th>

            <th class="PadLeft">
              Player(s)
            </th>
            <th class="HideMovResult">
              Nat.
            </th>
            <template v-if="data.show_winnings == 'B'">
              <th style="padding-left: 10px">Winnings</th>
            </template>
            <template v-else-if="data.show_winnings !== 'B'">
              <th style="padding-left: 10px;">
                <span
                  style="padding-left: 10px"
                  v-show="data.show_winnings == 'Y'"
                  >Winnings</span
                >
                <span v-show="data.show_winnings == 'P'">
                  <span v-hide="data.show_points_name.length > 0">Points</span>
                  <span v-show="data.show_points_name.length > 0">{{
                    data.show_points_name
                  }}</span>
                </span>
              </th>
            </template>
            <template
              v-if="data.show_winnings == 'B' && data.have_points == 'Y'"
            >
              <th>{{ data.show_points_name }}</th>
            </template>
            <template v-if="match === 'N'">
              <th class="PadLeft">
                Par
              </th>
              <th class="PadLeft">
                Score
              </th>
              <th
                v-for="(i, roundIt) in range(1, roundsPlayed)"
                :key="roundIt"
                class="PadLeft HideMovResult"
              >
                R{{ i }}
              </th>
              <th v-if="data.have_oom == 'Y'" class="hideOnMob">
                Points
              </th>
              <th v-if="config.VUE_APP_PLAYER_ICON === 'Y'"></th>
            </template>
            <th></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="(tabledata, index) in Eds">
          <template v-if="home == false && isMobile(true)">
            <!-- <tr :key="index" v-if="index == '4'">
              <td colspan="12">
                <script type="application/javascript">
                  window.googletag = window.googletag || { cmd: [] };
                  googletag.cmd.push(function() {
                    googletag
                      .defineSlot(
                        "/22264165340/LET21_RTCDS_MOBILE_320x50two",
                        [320, 50],
                        "div-gpt-ad-1615800857323-0"
                      )
                      .addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    googletag.pubads().collapseEmptyDivs();
                  });
                </script>
                <div
                  id="div-gpt-ad-1615800857323-0"
                  style="width: 320; height: 50px; margin: auto;"
                >
                  <script type="application/javascript">
                    googletag.cmd.push(function() {
                      googletag.display("div-gpt-ad-1615800857323-0");
                    });
                  </script>
                </div>
              </td>
            </tr> -->
          </template>
          <template v-else-if="home == false">
            <!-- <tr :key="index" v-if="index == '4'">
              <td colspan="12">
                <script type="application/javascript">
                  window.googletag = window.googletag || { cmd: [] };
                  googletag.cmd.push(function() {
                    googletag
                      .defineSlot(
                        "/22264165340/LET21_RTCDS_MOBILE_320x50two",
                        [728, 90],
                        "div-gpt-ad-1615800857323-0"
                      )
                      .addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    googletag.pubads().collapseEmptyDivs();
                  });
                </script>
                <div
                  id="div-gpt-ad-1615800857323-0"
                  style="width: 728px; height: 90px; margin: auto;"
                >
                  <script type="application/javascript">
                    googletag.cmd.push(function() {
                      googletag.display("div-gpt-ad-1615800857323-0");
                    });
                  </script>
                </div>
              </td>
            </tr> -->
          </template>
          <tr
            @click.stop="rowClicked(index)"
            :key="index"
            v-bind:class="{
              'homeTd-size': home === true,
              'homeTd-sizehover': home === true,
              drawHome: home === true && tablePick === 'Draw',
              takeTR: takeover == true,
              cut: tabledata.pos === 'CUT'
            }"
          >
            <template v-if="tablePick === 'Final'">
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.pos }}
              </td>
              <td class="posnum" v-if="tabledata.pos !== 'CUT' && index !== 0">
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum" v-else-if="index === 0">
                <span>
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td v-else-if="tabledata.pos !== 'CUT'" class="noPos">
                <span>.</span>
              </td>
              <template v-if="home == true || isMobile(true)">
                <td
                  class=""
                  v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT'"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span>
                  <span v-if="home !== true"> - {{ tabledata.team_name }}</span>
                  <span v-if="tabledata.sponsored === 'Y' && home !== true">
                    <img
                      class="titliestLogo"
                      src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2021/03/titleist_oom-copy.png"
                    />
                  </span>
                </td>
              </template>
              <template v-else>
                <td
                  class="namePointer"
                  v-if="tabledata.playerno !== 'Cat' && tabledata.pos !== 'CUT'"
                  @click="playerCard"
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.pro_ind == 'Am'">(a)</span>
                  <span v-if="home !== true">  {{ tabledata.team_name }}</span>
                  <span v-if="tabledata.sponsored === 'Y' && home !== true">
                    <img
                      class="titliestLogo"
                      src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2021/03/titleist_oom-copy.png"
                    />
                  </span>
                </td>
              </template>

              <td
                class="mobHide HideMovResult"
                v-if="tabledata.pos !== 'CUT' && home !== true"
              >
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                </span>
              </td>
              <template v-if="data.show_winnings == 'B' && data.have_points == 'Y'">
                <td
                  v-if="
                    tabledata.playerno !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      home !== true
                  "
                  class="hideOnMob"
                >
                  {{
                    tabledata.winnings
                  }}
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.pos !== 'CUT' &&
                    home !== true
                "
                class="hideOnMob"
              >
                <span v-if="home !== true">
                  <template v-if="data.show_winnings !== 'B'">
                    <span v-if="data.show_winnings == 'Y'">{{
                      tabledata.winnings
                    }}</span>
                    <span v-if="data.show_winnings == 'P'">{{
                      tabledata.points
                    }}</span>
                  </template>
                  <template
                    v-else-if="
                      data.show_winnings == 'B' && data.have_points == 'Y'
                    "
                  >
                    {{ tabledata.points_both }}
                  </template>
                  <template v-else>
                    <span>{{ tabledata.winnings }}</span>
                  </template>
                </span>
                <span v-if="home === true">{{ tabledata.score }}</span>
              </td>
              <template v-if="match === 'N' && tabledata.playerno !== 'Cat'">
                <td v-if="tabledata.vspar < 0" class="up">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.vspar > 0" class="down">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos !== 'CUT'">
                  {{ tabledata.vspar }}
                </td>
                <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up">
                  {{ tabledata.score }}
                </td>
                <td
                  v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
                  class="down"
                >
                  {{ tabledata.score }}
                </td>
                <td v-else-if="roundsPlayed > 1 && tabledata.pos !== 'CUT'">
                  {{ tabledata.score }}
                </td>
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="hideOnMob"
                  v-show="tabledata.pos !== 'CUT' && home !== true"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up"
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span
                    v-else-if="
                      tabledata['score_R' + i] < data.course_total_par.slice(1)
                    "
                    :class="up"
                    >{{ tabledata["score_R" + i] }}</span
                  >
                  <span
                    v-else-if="
                      tabledata['score_R' + i] > data.course_total_par.slice(1)
                    "
                    :class="down"
                    >{{ tabledata["score_R" + i] }}</span
                  >
                  <span v-else>{{ tabledata["score_R" + i] }}</span>
                </td>
              </template>
              <template v-if="home != true">
                <td v-if="data.have_oom == 'Y' && tabledata.pos !== 'CUT'">
                  {{ tabledata.points }}
                </td>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    tabledata.pos !== 'CUT'
                "
              >
                <a
                  :href="'/player-profiles/' + tabledata.member_no"
                  v-if="tabledata.profile == 'Y'"
                  target="_blank"
                >
                  <span class="iconRight">
                    <font-awesome-icon
                      class="icon"
                      :icon="['fa', 'chevron-right']"
                    />
                  </span>
                </a>
              </td>
            </template>
          </tr>
          <tr
            @click.stop="rowClicked(rowClicked === -1)"
            v-if="index === clickedRow"
            class="tr-kids"
            :key="index + Math.random()"
          >
            <td id="reportCard" colspan="12">
              <PlayerReportCard
                :data="data"
                :playerCardData="playerCardData"
                :config="config"
                :actualRound="data.pft_round"
                :roundsPlayed="roundsplayed"
                :scoreType="data.scores_type"
                :team="team"
                :courses="courses"
                :tmparams="tmparams"
                :sg_avg="sg_avg"
                :hide_sg_sc="hide_sg_sc"
                :driving_dist="driving_dist"
                :drive_acc="drive_acc"
                :sand_saves="sand_saves"
                :gir="gir"
                :putting_ave="putting_ave"
                :pgir="pgir"
              />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="home === true">
      <b-container>
        <b-row class="homeLeaderHome mobNocontainer">
          <b-col>
            <b-nav-item
              class="fullNav"
              :to="{
                name: 'reports-page',
                query: {
                  url: this.report,
                  id: season,
                  code: code,
                  title: title
                }
              }"
            >
              <h3 class="FullLeaderboard" :class="{extraPad : multi_tourns == 'Y', morepad: takeover == true}">Full Leaderboard</h3>
            </b-nav-item>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import PlayerReportCard from "@/components/playerReportCard.vue";
import PlayerReportCard from "@/components/orginalPlayerCard.vue";
import Information from "@/components/information.vue";
export default {
  name: "results",
  props: [
    "data",
    "roundsplayed",
    "Stableford",
    "previousData",
    "home",
    "title",
    "report",
    "code",
    "season",
    "takeover",
    "config",
    "team",
    "match",
    "live",
    "RTCDS",
    "showGender",
    "tmparams",
    "roundsP",
    "multi_tourns",
    "web_sponsor",
    "show_info_web",
    "hide_score_card",
    "tm_params",
  ],
  components: {
    PlayerReportCard,
    Information
  },
  data() {
    return {
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      openRow: ''
    };
  },
  methods: {
    isMobile() {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.home == true) {
        // console.log("TRUE");
        this.clickedRow = this.reportTitle;
      } else {
        if (
          (this.tablePick === "Final" && this.clickedRow !== index)
        )
          this.clickedRow = index;
        else this.clickedRow = -1;
      }
    },
    playerCard: function(event) {
      console.log("in player card");
      console.log();
      var cardID = event.target.getAttribute("title");
      return (
        (this.cardID = cardID),
        axios
          .get(
            process.env.VUE_APP_TIC_BASE +
              this.tmparams.tm_params.season_code +
              "/" +
              this.tmparams.tm_params.season_code +
              "-" +
              this.tmparams.code +
              "-cards-" +
              this.cardID +
              ".json?randomadd=" +
              new Date().getTime()
          )
          .then(
            response => (
              (this.playerCardData = response.data),
              (this.sg_avg = response.data.sg_avg),
              (this.hide_sg_sc = response.data.hide_sg_sc),
              (this.driving_dist = response.data.stats.perf_stats.driving_dist),
              (this.drive_acc = response.data.stats.perf_stats.drive_acc),
              (this.sand_saves = response.data.stats.perf_stats.sand_saves),
              (this.gir = response.data.stats.perf_stats.gir),
              (this.putting_ave = response.data.stats.perf_stats.putting_ave),
              (this.pgir = response.data.stats.perf_stats.pgir)
            )
          )
      );
    }
  },
  computed: {
    tablePick: function(picked) {
      if (this.title === "Tournament Entries") picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        this.title.includes("Scores") ||
        this.title.includes("Scoreboard")
      )
        picked = "Score";
      else if (
        this.title.includes("Final") ||
        this.title.includes("Statistics")
      )
        picked = "Final";
      else if (this.title.includes("Live")) picked = "Live";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (this.title.includes("Final") || this.title.includes("Statistics"))
          reportData = this.data.result.result_entry;
        return reportData;
      } else {
        if (this.title.includes("Final") || this.title.includes("Statistics"))
          if (this.multi_tourns == 'Y') { 
            reportData = this.data.result.result_entry.slice(0, 4);
          } else {
            reportData = this.data.result.result_entry.slice(0, 5); 
          }
        return reportData;
      }
    }
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
    },
    immediate: true,
    deep: true
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
};
</script>


<style scoped>
/* =========================================
   GENERAL / INFORMATION
========================================= */

::v-deep img.informationImg.not-collapsed,
::v-deep img.informationImg.collapsed {
  width: 15px;
}

::v-deep .informationCLass {
  margin-top: 0 !important;
}

::v-deep td.namePointer,
::v-deep td.PlayerName {
  cursor: pointer;
}

::v-deep td.namePointer:hover,
::v-deep td.PlayerName:hover,
::v-deep .iconRight:hover {
  color: #c99b32 !important;
}

::v-deep tr:hover {
  background-color: #f0f4f9 !important;
}

::v-deep tr.homeTd-size.homeTd-sizehover:hover {
  background-color: #f0f4f9 !important;
}

.hideRepresentsHome,
.natNone,
.homeHide {
  display: none;
}

/* =========================================
   PLAYER DETAILS
========================================= */

p.homePlayername,
td.homePlayername {
  color: #26354b;
}

a.homePlayername {
  color: #26354b;
  font-weight: 600;
}

a.homeResult {
  color: #175b98 !important;
  font-weight: 600;
}

td > a {
  color: #172e50;
  font-weight: 600;
  text-decoration: none;
}

th.representsText,
td.representsText {
  text-align: left !important;
}

/* =========================================
   LEADERBOARD HEADINGS
========================================= */

h3.FullLeaderboard {
  font-size: 14pt;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 4px;
}

h3.FullLeaderboard.extraPad {
  padding-top: 14px;
  padding-bottom: 9px;
}

h3.FullLeaderboard.extraPad.morepad {
  padding-top: 14px;
  padding-bottom: 16px;
}

/* =========================================
   MAIN TABLE DESIGN
========================================= */

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  color: #26354b;
  font-size: 14px;
}

thead > tr {
  color: #fff;
}

th {
  position: sticky;
  background: #09264b;
  color: #fff !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 14px 12px;
  border: none;
  border-bottom: 3px solid #c99b32;
  z-index: 1;
}

td {
  font-size: 14px;
  padding: 12px;
  color: #35445a;
  vertical-align: middle;
  border: none;
  border-bottom: 1px solid #edf0f4;
}

td:first-child,
th:first-child {
  text-align: center;
}

th:nth-child(3),
td:nth-child(3) {
  text-align: center;
}

tr:nth-child(odd) {
  background-color: #fff;
}

tr:nth-child(even) {
  background-color: #f7f9fc;
}

.odd {
  background-color: #fff !important;
  padding-bottom: 0;
  padding-top: 0;
}

.even {
  background-color: #f7f9fc !important;
  padding-bottom: 0;
  padding-top: 0;
}

::v-deep tbody tr:hover {
  background-color: #f0f4f9 !important;
  transition: background-color 0.15s ease;
}

/* =========================================
   LEADERBOARD ROWS
========================================= */

tr.homeTd-size {
  background-color: #fff !important;
  color: #35445a;
  border-top: 1px solid #edf0f4 !important;
}

tr.homeTd-size > td {
  font-size: 13px;
  color: #35445a;
  padding-top: 8px;
  padding-bottom: 8px;
}

tr.homeTd-size.homeTd-sizehover.takeTR > td.posnum {
  margin-top: 7px;
  margin-bottom: 7px;
}

tr.drawHome {
  border-top: 0 !important;
}

tr.drawHome > td.drawPos {
  top: 0;
}

tr.drawHome > td > a {
  color: #172e50 !important;
}

/* =========================================
   POSITIONS / SCORES
========================================= */

.posCell,
.scoreCell {
  width: 2%;
}

td.posnum {
  padding: 5px;
  padding-top: 4px;
  padding-bottom: 10px;
  display: block;
  max-width: 58px;
  margin: 8px auto 0;
  font-weight: 700;
  color: #172e50;
}

td.posnum > span {
  padding: 5px;
  display: block;
  max-width: 58px;
}

.noPos > span {
  color: transparent;
  padding: 5px;
  display: block;
  max-width: 58px;
}

.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0 !important;
  position: relative;
  top: 3px;
}

/* =========================================
   CUT LINE
========================================= */

.cut {
  padding: 6px 6px 6px 8px !important;
  font-size: 19px !important;
  vertical-align: middle;
  background: #aa0003 !important;
  color: #fff !important;
}

.cut > td > span {
  color: #fff;
}

/* =========================================
   HOME / LEADERBOARD HEADER
========================================= */

.homeLeader,
.homeLeaderHome {
  text-align: center !important;
  background-color: #09264b !important;
  color: #fff;
  padding: 0 !important;
}

.homeLeader {
  padding-bottom: 4px !important;
}

.homeLeaderHome {
  padding-bottom: 0 !important;
}

.homeHead {
  font-size: 11pt;
  padding: 20px 20px 0;
  text-align: center;
  font-weight: 500;
}

.homecourseDates {
  font-size: 11pt;
  padding-bottom: 15px;
}

.home {
  width: 100%;
  top: 13px;
  right: 30%;
}

.homeCell {
  padding: 12px;
  font-size: 10pt;
}

.homeCell > a {
  color: #172e50;
  font-weight: 600;
}

/* =========================================
   TOURNAMENT TITLE
========================================= */

.title {
  text-align: center;
  background-color: #09264b;
  color: #fff;
  margin-left: 0;
  margin-right: 0;
}

.title > .col > h3 {
  color: #fff;
  padding: 15px 0 15px 10px;
  font-size: 13pt;
  margin: 0;
  line-height: 24px;
  text-transform: capitalize;
  background-color: #09264b;
  text-align: left;
  font-weight: 600;
}

.tLogo {
  width: 65px;
  margin-top: -5px;
  margin-right: 15px;
}

.sponLogo {
  margin-top: 15px;
  float: right;
  padding-right: 27px;
  color: #fff;
  font-size: 12pt;
}

.title > p {
  font-size: 16px !important;
  margin-bottom: 0;
}

td.catD {
  background: #09264b;
  color: #fff;
}

/* =========================================
   COURSE / SPONSOR LOGOS
========================================= */

.courseLogo {
  width: 68px;
  padding-top: 25px;
  max-width: 84px;
  min-height: 70px;
}

img.courseLogo.ss {
  width: 50px;
}

img.titliestLogo {
  height: 12px;
  margin-bottom: 1px;
  margin-left: 10px;
}

.titlest {
  margin-top: -2.2px;
  margin-left: 10px;
  width: 37px;
}

.sponsorHome {
  margin-top: -2.2px;
  margin-left: 10px;
  width: 37px;
}

/* =========================================
   FLAGS / MOVEMENT
========================================= */

.flag {
  width: 30px;
  box-shadow: 0 0 1px #555;
}

.up {
  color: #a52a2a;
}

.down {
  color: #1e90ff;
}

.text-down {
  background: transparent;
  text-shadow: 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}

/* =========================================
   NAVIGATION / MISC
========================================= */

.fullNav {
  padding-top: 0 !important;
  display: block !important;
}

.fullNav > .nav-link {
  padding: 0 1rem;
  color: #fff;
}

th.PadLeft {
  padding-left: 10px;
}

th.playersName-score {
  padding-left: 10px;
}

td.centerTime,
th.Timecenter {
  text-align: center;
}

td.drawName > a {
  color: #172e50;
}

.table-responsive {
  margin-bottom: 0;
}

/* =========================================
   RESPONSIVE
========================================= */

@media only screen and (max-width: 1024px) {
  .home {
    width: 100% !important;
    position: inherit !important;
    top: 30px;
    right: 30%;
  }

  .home > div > div {
    max-width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  img.titliestLogo {
    height: 12px;
    margin-bottom: 1px;
    margin-left: 0;
  }

  .title > .col > h3 {
    padding: 15px 0 15px 10px;
    font-size: 11pt;
    line-height: 24px;
    text-align: left;
    font-weight: 600;
  }

  .titleLeftmobileWidth {
    width: 80%;
    max-width: 80%;
  }

  .informationMobilewidth {
    width: 20%;
    max-width: 20%;
  }

  .home {
    position: inherit;
    width: 100%;
  }

  .homeLeader {
    margin-left: -40px;
  }

  .homewidthTakover {
    margin-left: -15px;
  }

  .Desk {
    display: none;
  }

  th {
    padding: 11px 8px;
    font-size: 10px;
  }

  td {
    padding: 10px 8px;
    font-size: 12px;
  }
}

@media only screen and (max-width: 480px) {
  .hideOnMob {
    display: none;
  }

  .tableMob {
    width: 275%;
  }

  .home {
    position: inherit;
    width: 100%;
  }

  ::v-deep tr > :nth-child(2) {
    font-size: 10pt;
  }

  ::v-deep th {
    font-size: 10pt;
    padding: 10px 7px;
  }

  ::v-deep td {
    font-size: 10pt;
    padding: 10px 8px;
  }

  ::v-deep .dropdown {
    width: 100%;
    padding-right: 12px;
  }

  ::v-deep .HideMovResult {
    display: none;
  }
}
</style>

